export const environment = {
    production: false,
    cameraLocationsUrl: "https://services.arcgis.com/8lRhdTsQyJpO52F1/arcgis/rest/services/Traffic_Cameras_View/FeatureServer/0",
    request_url: "https://services.arcgis.com/8lRhdTsQyJpO52F1/ArcGIS/rest/services/Video_Footage_Requests_view/FeatureServer"
};